/* The Certified Collection — storefront behaviour */
(function () {
  'use strict';
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    var s = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + s;
  }

  /* ---------- drawers ---------- */
  function openDrawer(el) {
    if (!el) return;
    el.classList.add('is-on');
    document.body.style.overflow = 'hidden';
    var f = el.querySelector('button,a,input');
    if (f) f.focus();
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-on');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    if (open) { e.preventDefault(); openDrawer($('#' + open.getAttribute('data-drawer-open'))); return; }
    var close = e.target.closest('[data-drawer-close]');
    if (close) { e.preventDefault(); closeDrawer(close.closest('[data-drawer]')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('[data-drawer].is-on').forEach(closeDrawer);
  });

  /* ---------- cart ---------- */
  function renderCart(cart) {
    var body = $('[data-cart-body]'), foot = $('[data-cart-foot]');
    $$('[data-cart-count]').forEach(function (n) {
      n.textContent = cart.item_count;
      n.hidden = cart.item_count === 0;
    });
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML = '<div class="cart__empty"><p>Your bag is empty.</p><a class="lnk" href="/collections/all">Shop all hair</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
      var opts = (it.options_with_values || [])
        .filter(function (o) { return o.value && o.value !== 'Default Title'; })
        .map(function (o) { return o.value; }).join(' · ');
      return '<div class="cart__line">' +
        '<a href="' + it.url + '"><div class="fr">' + (img ? '<img src="' + img + '" alt="">' : '') + '</div></a>' +
        '<div><a href="' + it.url + '" style="font-weight:600;font-size:13.5px">' + it.product_title + '</a>' +
        (opts ? '<div class="fine">' + opts + '</div>' : '') +
        '<div style="display:flex;justify-content:space-between;align-items:center;margin-top:8px">' +
        '<div class="qty" style="height:38px">' +
        '<button type="button" data-line="' + it.key + '" data-to="' + (it.quantity - 1) + '" aria-label="Decrease">&minus;</button>' +
        '<input value="' + it.quantity + '" readonly aria-label="Quantity">' +
        '<button type="button" data-line="' + it.key + '" data-to="' + (it.quantity + 1) + '" aria-label="Increase">+</button>' +
        '</div><strong style="font-size:13.5px">' + money(it.final_line_price) + '</strong></div></div></div>';
    }).join('');
    if (foot) { foot.hidden = false; $('[data-cart-total]').textContent = money(cart.total_price); }
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line]');
    if (!b) return;
    e.preventDefault();
    fetch(window.CC.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: b.getAttribute('data-line'), quantity: +b.getAttribute('data-to') })
    }).then(function (r) { return r.json(); }).then(renderCart);
  });

  /* add to bag — every form on the site routes through here */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-add-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var was = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    fetch(window.CC.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().catch(function () {
          throw new Error('Could not add to bag. Please try again.');
        });
      })
      .then(function (res) {
        if (res.status && res.status !== 200) throw new Error(res.description || 'Could not add');
        return fetchCart();
      })
      .then(function () {
        if (btn) { btn.textContent = was; btn.disabled = false; }
        openDrawer($('#CartDrawer'));
      })
      .catch(function (err) {
        if (btn) { btn.textContent = was; btn.disabled = false; }
        var w = form.querySelector('[data-add-error]');
        if (w) { w.textContent = err.message; w.hidden = false; }
      });
  });

  /* ---------- accordions ---------- */
  document.addEventListener('click', function (e) {
    var h = e.target.closest('.acc__h');
    if (!h) return;
    var on = h.getAttribute('aria-expanded') === 'true';
    h.setAttribute('aria-expanded', String(!on));
    var c = h.nextElementSibling;
    if (c) c.classList.toggle('is-on', !on);
  });

  /* ---------- product: variants + gallery + sticky bar ---------- */
  function initProduct(root) {
    var data = $('[data-variants]', root);
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var form   = $('[data-add-form]', root);
    var idIn   = $('[data-variant-id]', root);
    var priceN = $('[data-price-now]', root);
    var priceW = $('[data-price-was]', root);
    var btn    = $('[data-add-btn]', root);
    var stickP = $('[data-stick-price]', root);

    function current() {
      var chosen = $$('[data-opt]', root).map(function (g) {
        var on = g.querySelector('[aria-checked=true]');
        return on ? on.getAttribute('data-value') : null;
      });
      return variants.find(function (v) {
        return chosen.every(function (c, i) { return c === null || v.options[i] === c; });
      });
    }

    function paint() {
      var v = current();
      if (!v) {
        if (btn) { btn.textContent = 'Unavailable'; btn.disabled = true; }
        return;
      }
      if (idIn) idIn.value = v.id;
      if (priceN) priceN.textContent = money(v.price);
      if (priceW) {
        var show = priceW.getAttribute('data-honest') !== 'true' && v.compare_at_price > v.price;
        priceW.hidden = !show;
        if (show) priceW.textContent = money(v.compare_at_price);
      }
      if (stickP) stickP.textContent = money(v.price);
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? 'Add to bag' : 'Sold out';
      }
      $$('[data-fin-amount]', root).forEach(function (n) { n.textContent = money(Math.ceil(v.price / 4)); });
      if (history.replaceState && v.id) {
        var u = new URL(location.href); u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u);
      }
    }

    $$('[data-opt] .sw', root).forEach(function (sw) {
      sw.addEventListener('click', function () {
        $$('.sw', sw.parentNode).forEach(function (s) { s.setAttribute('aria-checked', 'false'); });
        sw.setAttribute('aria-checked', 'true');
        var lbl = sw.closest('[data-opt]').querySelector('[data-opt-val]');
        if (lbl) lbl.textContent = sw.getAttribute('data-value');
        paint();
      });
    });
    paint();

    /* gallery */
    var main = $('[data-gal-main] img', root);
    var thumbs = $$('[data-gal-thumb]', root);

    function showImage(i) {
      if (!thumbs.length) return;
      if (i < 0) i = thumbs.length - 1;
      if (i >= thumbs.length) i = 0;
      var t = thumbs[i];
      thumbs.forEach(function (x) { x.setAttribute('aria-current', 'false'); });
      t.setAttribute('aria-current', 'true');
      if (main) { main.src = t.getAttribute('data-full'); main.alt = t.getAttribute('data-alt') || ''; }
      var c = $('[data-gal-count]', root);
      if (c) c.textContent = (i + 1) + ' / ' + thumbs.length;
      t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
    function currentIndex() {
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].getAttribute('aria-current') === 'true') return i;
      }
      return 0;
    }

    /* swipe the main image on a phone — 93% of this store's traffic */
    var stage = $('[data-gal-main]', root);
    if (stage && thumbs.length > 1) {
      var x0 = null, y0 = null;
      stage.addEventListener('touchstart', function (e) {
        x0 = e.changedTouches[0].clientX; y0 = e.changedTouches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
          showImage(currentIndex() + (dx < 0 ? 1 : -1));
        }
        x0 = null;
      }, { passive: true });
      stage.addEventListener('click', function () { showImage(currentIndex() + 1); });
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function (e) { e.preventDefault(); showImage(i); });
    });

    /* sticky buy bar — 93% of this store's sessions are on a phone */
    var stick = $('[data-stick]', root), anchor = form;
    if (stick && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        stick.classList.toggle('is-on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0);
      }, { rootMargin: '0px' }).observe(anchor);
      $('[data-stick-add]', stick).addEventListener('click', function () {
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  }

  /* ---------- the fit finder ---------- */
  function initQuiz(root) {
    var payload = $('[data-quiz-data]', root);
    if (!payload) return;
    var units = JSON.parse(payload.textContent);
    var answers = {};
    var steps = $$('.qstep', root);
    var at = 0;

    function show(i) {
      at = i;
      steps.forEach(function (s, n) { s.classList.toggle('is-on', n === i); });
      $$('.qdot', root).forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
      $('[data-quiz-result]', root).classList.remove('is-on');
    }

    $$('.qopt', root).forEach(function (o) {
      o.addEventListener('click', function () {
        var key = o.closest('[data-q]').getAttribute('data-q');
        $$('.qopt', o.parentNode).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        o.setAttribute('aria-pressed', 'true');
        answers[key] = o.getAttribute('data-value');
        var next = $('[data-quiz-next]', o.closest('.qstep'));
        if (next) next.disabled = false;
      });
    });

    $$('[data-quiz-next]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        if (at < steps.length - 1) show(at + 1); else result();
      });
    });
    $$('[data-quiz-back]', root).forEach(function (b) {
      b.addEventListener('click', function () { if (at > 0) show(at - 1); });
    });

    function score(u) {
      var s = 0;
      if (answers.style && u.style === answers.style) s += 40;
      if (answers.texture) {
        /* 'any' = texture genuinely unknown for that product: give partial
           credit so it stays eligible, but never outrank a real match. */
        if (u.texture === answers.texture) s += 30;
        else if (u.texture === 'any') s += 12;
      }
      if (answers.length) {
        var want = +answers.length;
        if (u.lengths && u.lengths.length) {
          var near = u.lengths.reduce(function (a, b) {
            return Math.abs(b - want) < Math.abs(a - want) ? b : a;
          });
          s += Math.max(0, 20 - Math.abs(near - want) * 2);
        }
      }
      if (u.available) s += 15;
      return s;
    }

    function result() {
      var pool = units.slice().sort(function (a, b) { return score(b) - score(a); });
      var pick = pool.filter(function (u) { return u.available; })[0] || pool[0];
      if (!pick) return;

      var box = $('[data-quiz-result]', root);
      steps.forEach(function (s) { s.classList.remove('is-on'); });
      box.classList.add('is-on');

      var why = [];
      if (answers.style) why.push(answers.style === 'wig' ? 'a ready-to-wear unit' : 'bundles you install yourself');
      if (answers.texture) why.push(answers.texture);
      if (answers.length) why.push(answers.length + '″');
      $('[data-res-why]', box).textContent = 'Matched on ' + why.join(' · ') + '.';
      $('[data-res-img]', box).src = pick.image || '';
      $('[data-res-name]', box).textContent = pick.title;
      $('[data-res-price]', box).textContent = money(pick.price);
      $('[data-res-link]', box).href = pick.url;
      var vid = $('[data-res-variant]', box);
      if (vid) vid.value = pick.variant_id;
      var addBtn = $('[data-res-add]', box);
      if (addBtn) {
        addBtn.disabled = !pick.available;
        addBtn.textContent = pick.available ? 'Add to bag' : 'Sold out';
      }
    }

    $$('[data-quiz-restart]', root).forEach(function (b) {
      b.addEventListener('click', function () { answers = {}; 
        $$('.qopt', root).forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        $$('[data-quiz-next]', root).forEach(function (n) { n.disabled = true; });
        show(0);
      });
    });
    show(0);
  }


  /* ---------- shoppable video rail ---------- */
  function initRail(root) {
    var rail = $('[data-rail]', root);
    if (!rail) return;
    var cards = $$('[data-vcard]', rail);

    /* Nothing is fetched until a card is actually near the viewport. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var v = e.target.querySelector('video');
          if (v && v.dataset.src && !v.src) { v.src = v.dataset.src; v.load(); }
          if (v) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
          io.unobserve(e.target);
        });
      }, { rootMargin: '250px' });
      cards.forEach(function (c) { io.observe(c); });
    } else {
      cards.forEach(function (c) {
        var v = c.querySelector('video');
        if (v && v.dataset.src) v.src = v.dataset.src;
      });
    }

    var prev = $('[data-rail-prev]', root), next = $('[data-rail-next]', root);
    function step() { var c = cards[0]; return c ? c.offsetWidth + 12 : 280; }
    function sync() {
      if (!prev || !next) return;
      prev.disabled = rail.scrollLeft < 8;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 8;
    }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    rail.addEventListener('scroll', sync, { passive: true });
    sync();

    cards.forEach(function (card, i) {
      var hit = card.querySelector('.vcard__hit');
      if (hit) hit.addEventListener('click', function () { openViewer(cards, i); });
    });
  }

  var viewer = null, viewerIdx = 0, viewerCards = [];
  function buildViewer() {
    if (viewer) return viewer;
    viewer = document.createElement('div');
    viewer.className = 'vwr';
    viewer.innerHTML =
      '<button class="vwr__close" aria-label="Close">&times;</button>' +
      '<button class="vwr__nav vwr__nav--prev" aria-label="Previous">&#8249;</button>' +
      '<button class="vwr__nav vwr__nav--next" aria-label="Next">&#8250;</button>' +
      '<div class="vwr__box">' +
        '<div class="vwr__media"><video playsinline loop controls></video></div>' +
        '<div class="vwr__buy" hidden>' +
          '<div class="vwr__top"><span class="vwr__name"></span><span class="vwr__price"></span></div>' +
          '<form data-add-form><input type="hidden" name="id" value=""><input type="hidden" name="quantity" value="1">' +
          '<button type="submit" class="btn">Add to bag</button></form>' +
          '<a class="lnk" href="#">See full details</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(viewer);
    viewer.querySelector('.vwr__close').addEventListener('click', closeViewer);
    viewer.addEventListener('click', function (e) { if (e.target === viewer) closeViewer(); });
    viewer.querySelector('.vwr__nav--prev').addEventListener('click', function () { showViewer(viewerIdx - 1); });
    viewer.querySelector('.vwr__nav--next').addEventListener('click', function () { showViewer(viewerIdx + 1); });
    return viewer;
  }
  function showViewer(i) {
    if (i < 0) i = viewerCards.length - 1;
    if (i >= viewerCards.length) i = 0;
    viewerIdx = i;
    var card = viewerCards[i], d = card.dataset;
    var srcEl = card.querySelector('video');
    var v = viewer.querySelector('video');
    var src = srcEl ? (srcEl.currentSrc || srcEl.src || srcEl.dataset.src ||
      (srcEl.querySelector('source') ? srcEl.querySelector('source').src : '')) : '';
    if (src) { v.src = src; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }

    var buy = viewer.querySelector('.vwr__buy');
    if (d.productUrl) {
      buy.hidden = false;
      viewer.querySelector('.vwr__name').textContent = d.productTitle || '';
      viewer.querySelector('.vwr__price').textContent = d.productPrice ? money(+d.productPrice) : '';
      viewer.querySelector('input[name=id]').value = d.variantId || '';
      viewer.querySelector('.lnk').href = d.productUrl;
      var b = buy.querySelector('button[type=submit]');
      var ok = d.available === 'true';
      b.disabled = !ok;
      b.textContent = ok ? 'Add to bag' : 'Sold out';
    } else { buy.hidden = true; }
  }
  function openViewer(cards, i) {
    viewerCards = cards;
    buildViewer().classList.add('is-on');
    document.body.style.overflow = 'hidden';
    showViewer(i);
  }
  function closeViewer() {
    if (!viewer) return;
    var v = viewer.querySelector('video');
    v.pause(); v.removeAttribute('src'); v.load();
    viewer.classList.remove('is-on');
    document.body.style.overflow = '';
  }
  document.addEventListener('keydown', function (e) {
    if (!viewer || !viewer.classList.contains('is-on')) return;
    if (e.key === 'Escape') closeViewer();
    if (e.key === 'ArrowRight') showViewer(viewerIdx + 1);
    if (e.key === 'ArrowLeft') showViewer(viewerIdx - 1);
  });

  /* ---------- overlay header ---------- */
  function initHeader() {
    var h = $('[data-hdr]');
    if (!h || !h.classList.contains('hdr--overlay')) return;
    var trip = Math.max(80, h.offsetHeight);
    function onScroll() {
      h.classList.toggle('is-stuck', window.scrollY > trip);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- boot ---------- */
  function boot() {
    $$('[data-product-root]').forEach(initProduct);
    $$('[data-quiz-root]').forEach(initQuiz);
    $$('[data-rail-root]').forEach(initRail);
    initHeader();
    fetchCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
